import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useUploadBulkGalleryImagesMutation } from "./galleryImagesApiSlice";
import { useGetGalleryEventsQuery } from "../galleryEvents/galleryEventsApiSlice";
import { useGetGalleryCategoriesQuery } from "../galleryCategories/galleryCategoriesApiSlice";

const BulkUploadGalleryImages = () => {

  const navigate = useNavigate();

  const [files, setFiles] = useState([]);
  const [event, setEvent] = useState("");
  const [category, setCategory] = useState("");
  const [takenAt, setTakenAt] = useState("");

  const { data: eventsData } = useGetGalleryEventsQuery();
  const { data: categoriesData } = useGetGalleryCategoriesQuery();

  const [uploadBulkImages, { isLoading }] =
    useUploadBulkGalleryImagesMutation();

  const handleFileChange = (e) => {

    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length > 20) {
      alert("Maximum 20 images allowed");
      return;
    }

    setFiles(selectedFiles);

  };

  const removeImage = (index) => {

    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!files.length) {
      alert("Please select images");
      return;
    }

    if (!event || !category) {
      alert("Event and Category required");
      return;
    }

    const formData = new FormData();

    files.forEach((file) => {
      formData.append("images", file);
    });

    formData.append("event", event);
    formData.append("category", category);
    formData.append("takenAt", takenAt);

    try {

      await uploadBulkImages(formData).unwrap();

      alert("Images uploaded successfully");

      navigate("/dashboard/gallery");

    } catch (err) {

      alert(err?.data?.message || "Upload failed");

    }

  };

  const events = eventsData?.data || [];
  const categories = categoriesData?.data || [];

  return (

    <div className="container mt-4">

      <h2 className="mb-4">Bulk Upload Gallery Images</h2>

      <form onSubmit={handleSubmit}>

        <div className="row mb-3">

          <div className="col-md-6">

            <label className="form-label">Event</label>

            <select
              className="form-select"
              value={event}
              onChange={(e) => setEvent(e.target.value)}
              required
            >

              <option value="">Select Event</option>

              {events.map((ev) => (
                <option key={ev._id} value={ev._id}>
                  {ev.title}
                </option>
              ))}

            </select>

          </div>

          <div className="col-md-6">

            <label className="form-label">Category</label>

            <select
              className="form-select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >

              <option value="">Select Category</option>

              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.title}
                </option>
              ))}

            </select>

          </div>

        </div>


        <div className="mb-3">

          <label className="form-label">Taken Date</label>

          <input
            type="date"
            className="form-control"
            value={takenAt}
            onChange={(e) => setTakenAt(e.target.value)}
          />

        </div>


        <div className="mb-3">

          <label className="form-label">Select Images</label>

          <input
            type="file"
            multiple
            accept="image/*"
            className="form-control"
            onChange={handleFileChange}
          />

        </div>


        {/* PREVIEW GRID */}

        {files.length > 0 && (

          <div className="row mb-3">

            {files.map((file, index) => (

              <div className="col-md-2 mb-3" key={index}>

                <div className="card">

                  <img
                    src={URL.createObjectURL(file)}
                    alt=""
                    className="card-img-top"
                    style={{ height: "120px", objectFit: "cover" }}
                  />

                  <div className="card-body text-center p-2">

                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => removeImage(index)}
                    >
                      Remove
                    </button>

                  </div>

                </div>

              </div>

            ))}

          </div>

        )}


        <button
          type="submit"
          className="btn btn-primary"
          disabled={isLoading}
        >

          {isLoading ? "Uploading..." : "Upload Images"}

        </button>

      </form>

    </div>

  );

};

export default BulkUploadGalleryImages;